import React, { useMemo } from 'react';
import { useAppSelector } from 'src/services/redux/app/store';
import { MenuItem } from './MenuItem';
import { reportsMenuCategories } from './reportsMenuConfig';

// fetchPermission ile aynı semantik: tek rol veya "ROLE_A || ROLE_B"
const hasRole = (authKeys: string[] | undefined, role: string): boolean => {
  if (!authKeys) return false;
  return role
    .split('||')
    .map((r) => r.trim())
    .some((r) => authKeys.includes(r));
};

const ReportsMegaMenu: React.FC = () => {
  const { user } = useAppSelector((state) => state.auth);
  const authKeys = user?.authorization_keys;

  // Yetkiye göre öğeleri filtrele; öğesi kalmayan kategori kolonunu gizle
  const visibleCategories = useMemo(
    () =>
      reportsMenuCategories
        .map((category) => ({
          ...category,
          items: category.items.filter((item) => hasRole(authKeys, item.role)),
        }))
        .filter((category) => category.items.length > 0),
    [authKeys],
  );

  return (
    <div className="row" data-kt-menu-dismiss="true">
      {visibleCategories.map((category) => (
        <div key={category.title} className="col-lg-3 border-left-lg-1">
          <div className="menu-inline menu-column menu-active-bg">
            <div className="menu-item">
              <div className="menu-content">
                <span className="menu-section fs-7 fw-bold text-muted text-uppercase ls-1 py-2">{category.title}</span>
              </div>
            </div>
            {category.items.map((item) => (
              <MenuItem key={item.to} to={item.to} title={item.title} hasBullet={true} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export { ReportsMegaMenu };
